import { atom } from "jotai";

import { currentBookingAtom } from "../../stores";

export const getRequestInfoAtom = atom((get) => {
  const booking = get(currentBookingAtom);
  return booking?.request;
});
